export enum ViewShareLinkMessage {
  CreateSharedLinkSuccess = 'Shared link "{viewName}" has been created',
}
